import { imageUrls, routes } from "@/constants/url";
import { Button, HighlightEmail, ShadowBox, Typography } from "@backpac/monica";
import { useNavigate, useSearchParams } from "react-router";

export function AuthErrorPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const message = searchParams.get("message") ?? "Something went wrong";

  return (
    <div className="bg-backgroundLight min-h-screen flex flex-col desktop:items-center desktop:justify-center">
      <div className="flex items-center justify-center px-4 pt-5 desktop:pt-0 desktop:px-0 w-full">
        <ShadowBox className="desktop:max-w-md py-8 px-6 space-y-6 text-center">
          <div className="flex flex-col gap-4 w-full">
            <img src={imageUrls.logo.desktopBlack} alt="logo" className="h-[28px] mb-4 self-center" />
            <Typography size="paragraphSm" className="text-center">
              <HighlightEmail
                transform={(email, key) => (
                  <span key={key} className="font-semibold">
                    {email}
                  </span>
                )}
              >
                {message}
              </HighlightEmail>
            </Typography>
          </div>
          <Button variant="black" size="lg" className="mx-auto" onClick={() => navigate(routes.AUTH.signin)}>
            Sign in
          </Button>
        </ShadowBox>
      </div>
    </div>
  );
}
